import { render, staticRenderFns } from "./UsertenantRelationTable.vue?vue&type=template&id=29556fe4&"
import script from "./UsertenantRelationTable.vue?vue&type=script&lang=js&"
export * from "./UsertenantRelationTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports